module.exports = __webpack_public_path__ + "372dc237d706ae716b007a6956f99928.fbx";